/* Rquiere de mixin.js */

var subscription = {
	data() {
		return {
			listSubscriptions: [],
			methodsSubscription: {
				get: 'subscriptions',
				getSusbcriptionsChurch: 'order/	subscriptions/church/',
				show: 'order/subscription/',
			},
			paginationSubscriptions: [],
			searchSubscriptions: '',
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		getOthersSubscriptionsChurch(churchId, orderId) {
			this.searchingOrders = true
			let param = "?notId=" + orderId
			let url = this.apiBackend + this.methodsSubscription.getSusbcriptionsChurch + churchId + param
			this.axiosActionIS(url, 'GET', 'getAllOrdersResult')
		},
		getSubscription(id) {
			let url = this.apiBackend + this.methodsSubscription.show + id
			console.log(url)
			this.axiosActionIS(url, 'GET', 'getSubscriptionResult')
		},
		getSubscriptionResult(response) {
			if (response.data.success === true) {
				this.sockets.subscribe('UPDATE_ORDER_' + this.id, (data) => { this.updateData(data.body) })
			} else {
				alert('Los datos no se obtuvieron en el formato esperado')
				console.log(response.data)
			}
			this.getSubscriptionResultLocal(response)
		},
		getSubscriptionResultLocal(response) {
			console.log('getSubscriptionResultLocal no está desarrollado', response)
		},
	},
};

export default subscription;